<template>
  <div class="ins-main rbcn-main rblt-main">
    <h1 class="rbcn-head groupHeading">{{$t('lang_men_lotterySolution')}}</h1>
    <section class="rbcn-pro">
      <div class="underLineHeading">
        <span>{{$t('lang_themeHeading_productAdvantage')}}</span>
      </div>
      <div class="rbcn-description themeDesc" v-html="$t('lang_lotterySolution_productAdvantage_narrative')"></div>
      <template v-if="isMobile">
        <div class="rbcn-banner">
          <carousel ref="carousel"
            :perPage="1" 
            :mouse-drag="false" 
            :navigationEnabled="false" 
            :paginationEnabled="true" 
            :loop="true"
            class="rbcn-slider"
          >
            <slide class="rbcn-slider-item">
              <div class="rbcn-pro-mobile rbcn-pro-1"></div>
              <span>{{this.$t('lang_labelSolution_productAdvantage_sort1')}}</span>
              <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_1.png" alt=""></div>
              <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort1_list')"></ol>
            </slide>
            <slide class="rbcn-slider-item">
              <div class="rbcn-pro-mobile rbcn-pro-2"></div>
              <span>{{this.$t('lang_labelSolution_productAdvantage_sort2')}}</span>
              <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_2.png" alt=""></div>
              <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort2_list')"></ol>
            </slide>
            <slide class="rbcn-slider-item">
              <div class="rbcn-pro-mobile rbcn-pro-3"></div>
              <span>{{this.$t('lang_labelSolution_productAdvantage_sort3')}}</span>
              <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_3.png" alt=""></div>
              <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort3_list')"></ol>
            </slide>
            <slide class="rbcn-slider-item">
              <div class="rbcn-pro-mobile rbcn-pro-4"></div>
              <span>{{this.$t('lang_labelSolution_productAdvantage_sort4')}}</span>
              <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_4.png" alt=""></div>
              <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort4_list')"></ol>
            </slide>
          </carousel>
          <a @click.prevent="prevSlide" class="prev-btn">
            <img :src='require(`@img/develop/photoarrow.png`)'>
          </a>
          <a @click.prevent="nextSlide" class="next-btn">
            <img :src='require(`@img/develop/photoarrow.png`)'>
          </a>
        </div>
      </template>
      <template v-else>
        <ul class="rbcn-pro-item clearfix">
          <li>
            <div class="rbcn-pro-mobile rbcn-pro-1"></div>
            <span>{{$t('lang_lotterySolution_productAdvantage_sort1')}}</span>
            <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_1.png" alt=""></div>
            <ol v-html="$t('lang_lotterySolution_productAdvantage_sort1_list')"></ol>
          </li>
          <li>
            <div class="rbcn-pro-mobile rblt-pro-2"></div>
            <span>{{$t('lang_lotterySolution_productAdvantage_sort2')}}</span>
            <div class="rbcn-pro-img"><img src="@img/rblt/rblt_pro_2.png" alt=""></div>
            <ol v-html="$t('lang_lotterySolution_productAdvantage_sort2_list')"></ol>
          </li>
          <li>
            <div class="rbcn-pro-mobile rbcn-pro-3"></div>
            <span>{{$t('lang_lotterySolution_productAdvantage_sort3')}}</span>
            <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_3.png" alt=""></div>
            <ol v-html="$t('lang_lotterySolution_productAdvantage_sort3_list')"></ol>
          </li>
          <li>
            <div class="rbcn-pro-mobile rbcn-pro-4"></div>
            <span>{{$t('lang_lotterySolution_productAdvantage_sort4')}}</span>
            <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_4.png" alt=""></div>
            <ol v-html="$t('lang_lotterySolution_productAdvantage_sort4_list')"></ol>
          </li>
        </ul>
      </template>
    </section>
    <section class="rbcn-display rblt-display">
      <div class="underLineHeading">
        <span>{{$t('lang_themeHeading_lotteryIntro')}}</span>
      </div>
      <div class="rbcn-description themeDesc" v-html="$t('lang_themeHeading_lotteryIntro_narrative')"></div>
      <section class="rblt-display-content clearfix">
        <div class="rblt-display-format-b">
          <div class="rblt-display-inner">
            <span>
              <i>{{$t('lang_lottery_60Min')}}</i>
            </span>
            <ul>
              <li><img src="@img/rblt/keno_logo_1.png" alt=""><span>{{$t('lang_lottery_60Min_chongqing')}}</span></li>
              <li><img src="@img/rblt/keno_logo_2.png" alt=""><span>{{$t('lang_lottery_60Min_beijing')}}</span></li>
              <li><img src="@img/rblt/keno_logo_3.png" alt=""><span>{{$t('lang_lottery_60Min_jiangxi')}}</span></li>
              <li><img src="@img/rblt/keno_logo_4.png" alt=""><span>{{$t('lang_lottery_60Min_tianjin')}}</span></li>
              <li><img src="@img/rblt/keno_logo_5.png" alt=""><span>{{$t('lang_lottery_60Min_shanghai')}}</span></li>
            </ul>
          </div>
        </div>
        <div class="rblt-display-format-s">
          <div class="rblt-display-inner">
            <span>
              <i>{{$t('lang_lottery_lowFrequency')}}</i>
            </span>
            <ul>
              <li><img src="@img/rblt/keno_logo_20.png" alt=""><span>{{$t('lang_lottery_lowFrequenc_3D')}}</span></li>
              <li><img src="@img/rblt/keno_logo_21.png" alt=""><span>{{$t('lang_lottery_lowFrequenc_P3')}}</span></li>
            </ul>
          </div>
        </div>
        <div class="rblt-display-format-m">
          <div class="rblt-display-inner">
            <span>
              <i>{{$t('lang_lottery_11Pick5')}}</i>
            </span>
            <ul>
              <li><img src="@img/rblt/keno_logo_15.png" alt=""><span>{{$t('lang_lottery_11Pick5_Guangdong')}}</span></li>
              <li><img src="@img/rblt/keno_logo_11.png" alt=""><span>{{$t('lang_lottery_11Pick5_jiangxi')}}</span></li>
              <li><img src="@img/rblt/keno_logo_12.png" alt=""><span>{{$t('lang_lottery_11Pick5_Shandong')}}</span></li>
              <li><img src="@img/rblt/keno_logo_14.png" alt=""><span>{{$t('lang_lottery_11Pick5_shanghai')}}</span></li>
            </ul>
          </div>
        </div>
        <div class="rblt-display-format-b">
          <div class="rblt-display-inner">
            <span>
              <i>{{$t('lang_lottery_quickDraw')}}</i>
            </span>
            <ul>
              <li><img src="@img/rblt/keno_logo_6.png" alt=""><span>{{$t('lang_lottery_quickDraw_rollingBet1')}}</span></li>
              <li><img src="@img/rblt/keno_logo_7.png" alt=""><span>{{$t('lang_lottery_quickDraw_rollingBet3')}}</span></li>
              <li><img src="@img/rblt/keno_logo_8.png" alt=""><span>{{$t('lang_lottery_quickDraw_rollingBet5')}}</span></li>
              <li><img src="@img/rblt/keno_logo_9.png" alt=""><span>{{$t('lang_lottery_quickDraw_tokyo')}}</span></li>
              <li><img src="@img/rblt/keno_logo_10.png" alt=""><span>{{$t('lang_lottery_quickDraw_korea')}}</span></li>
              <li><img src="@img/rblt/keno_logo_11.png" alt=""><span>{{$t('lang_lottery_quickDraw_Beijing')}}</span></li>
            </ul>
          </div>
        </div>
        <div class="rblt-display-format-m">
          <div class="rblt-display-inner">
            <span>
              <i>{{$t('lang_lottery_miniGame')}}</i>
            </span>
            <ul>
              <li><img src="@img/rblt/keno_logo_17.png" alt=""><span>{{$t('lang_lottery_miniGame_ladder')}}</span></li>
              <li><img src="@img/rblt/keno_logo_16.png" alt=""><span>{{$t('lang_lottery_miniGame_snail')}}</span></li>
              <li><img src="@img/rblt/keno_logo_19.png" alt=""><span>{{$t('lang_lottery_miniGame_airship')}}</span></li>
              <li><img src="@img/rblt/keno_logo_18.png" alt=""><span>{{$t('lang_lottery_miniGame_wechatRacing')}}</span></li>
            </ul>
          </div>
        </div>
        <div class="rblt-display-format">
          <div class="rblt-display-format-min">
            <div class="rblt-display-inner">
              <span>
                <i>{{$t('lang_lottery_fast3')}}</i>
              </span>
              <ul>
              <li><img src="@img/rblt/keno_logo_22.png" alt=""><span>{{$t('lang_lottery_fast3_Anhui')}}</span></li>
              </ul>
            </div>
          </div>
          <div class="rblt-display-format-min">
            <div class="rblt-display-inner">
              <span>
                <i>{{$t('lang_lottery_lucky28')}}</i>
              </span>
              <ul>
              <li><img src="@img/rblt/keno_logo_23.png" alt=""><span>{{$t('lang_lottery_lucky28')}}</span></li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="rblt-display-mobile">
        <ul class="clearfix">
          <li><img src="@img/rblt/keno_logo_1.png" alt=""><span>{{$t('lang_lottery_60Min_chongqing')}}</span></li>
          <li><img src="@img/rblt/keno_logo_2.png" alt=""><span>{{$t('lang_lottery_60Min_beijing')}}</span></li>
          <li><img src="@img/rblt/keno_logo_3.png" alt=""><span>{{$t('lang_lottery_60Min_jiangxi')}}</span></li>
          <li><img src="@img/rblt/keno_logo_4.png" alt=""><span>{{$t('lang_lottery_60Min_tianjin')}}</span></li>
          <li><img src="@img/rblt/keno_logo_5.png" alt=""><span>{{$t('lang_lottery_60Min_shanghai')}}</span></li>
          <li><img src="@img/rblt/keno_logo_6.png" alt=""><span>{{$t('lang_lottery_quickDraw_rollingBet1')}}</span></li>
          <li><img src="@img/rblt/keno_logo_7.png" alt=""><span>{{$t('lang_lottery_quickDraw_rollingBet3')}}</span></li>
          <li><img src="@img/rblt/keno_logo_8.png" alt=""><span>{{$t('lang_lottery_quickDraw_rollingBet5')}}</span></li>
          <li><img src="@img/rblt/keno_logo_9.png" alt=""><span>{{$t('lang_lottery_quickDraw_tokyo')}}</span></li>
          <li><img src="@img/rblt/keno_logo_10.png" alt=""><span>{{$t('lang_lottery_quickDraw_korea')}}</span></li>
          <li><img src="@img/rblt/keno_logo_11.png" alt=""><span>{{$t('lang_lottery_quickDraw_Beijing')}}</span></li>
          <li><img src="@img/rblt/keno_logo_12.png" alt=""><span>{{$t('lang_lottery_11Pick5_jiangxi')}}</span></li>
          <li><img src="@img/rblt/keno_logo_13.png" alt=""><span>{{$t('lang_lottery_11Pick5_Shandong')}}</span></li>
          <li><img src="@img/rblt/keno_logo_14.png" alt=""><span>{{$t('lang_lottery_11Pick5_shanghai')}}</span></li>
          <li><img src="@img/rblt/keno_logo_15.png" alt=""><span>{{$t('lang_lottery_11Pick5_Guangdong')}}</span></li>
          <li><img src="@img/rblt/keno_logo_16.png" alt=""><span>{{$t('lang_lottery_miniGame_snail')}}</span></li>
          <li><img src="@img/rblt/keno_logo_17.png" alt=""><span>{{$t('lang_lottery_miniGame_ladder')}}</span></li>
          <li><img src="@img/rblt/keno_logo_18.png" alt=""><span>{{$t('lang_lottery_miniGame_wechatRacing')}}</span></li>
          <li><img src="@img/rblt/keno_logo_19.png" alt=""><span>{{$t('lang_lottery_miniGame_airship')}}</span></li>
          <li><img src="@img/rblt/keno_logo_20.png" alt=""><span>{{$t('lang_lottery_lowFrequenc_3D')}}</span></li>
          <li><img src="@img/rblt/keno_logo_21.png" alt=""><span>{{$t('lang_lottery_lowFrequenc_P3')}}</span></li>
          <li><img src="@img/rblt/keno_logo_22.png" alt=""><span>{{$t('lang_lottery_fast3_Anhui')}}</span></li>
          <li><img src="@img/rblt/keno_logo_23.png" alt=""><span>{{$t('lang_lottery_lucky28')}}</span></li>
        </ul>
      </section>
    </section>
    <section class="rbcn-process">
      <div class="underLineHeading">
        <span>{{$t('lang_themeHeading_cooperation')}}</span>
      </div>
      <div class="rbcn-description themeDesc" v-html="$t('lang_themeHeading_cooperation_narrative')"></div>
      <div class="rbcn-process-step">
        <div 
          class="rbcn-step-1"
          :class="{'enable':ProcessShow === 1}"
          data-step="1" 
          @mouseover="changeProcess(1)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-1"></i>
            <i class="sprb_step-1-hover"></i>
          </div>
          <span>{{this.$t('lang_consultation')}}</span>
          <h3>{{this.$t('lang_consultation_msg')}}</h3>
        </div
        ><div 
          class="rbcn-step-2"
          :class="{'enable':ProcessShow === 2}"
          data-step="2" 
          @mouseover="changeProcess(2)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-2"></i>
            <i class="sprb_step-2-hover"></i>
          </div>
          <span>{{this.$t('lang_contractSigning')}}</span>
          <h3>{{this.$t('lang_contractSigning_msg')}}</h3>
        </div
        ><div 
          class="rbcn-step-3"
          :class="{'enable':ProcessShow === 3}"
          data-step="3" 
          @mouseover="changeProcess(3)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-3"></i>
            <i class="sprb_step-3-hover"></i>
          </div>
          <span>{{this.$t('lang_design')}}</span>
          <h3>{{this.$t('lang_design_msg')}}</h3>
        </div
        ><div 
          class="rbcn-step-4"
          :class="{'enable':ProcessShow === 4}"
          data-step="4" 
          @mouseover="changeProcess(4)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-4"></i>
            <i class="sprb_step-4-hover"></i>
          </div>
          <span>{{this.$t('lang_siteBuilding')}}</span>
          <h3>{{this.$t('lang_siteBuilding_msg')}}</h3>
        </div
        ><div 
          class="rbcn-step-5"
          :class="{'enable':ProcessShow === 5}"
          data-step="5" 
          @mouseover="changeProcess(5)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-5"></i>
            <i class="sprb_step-5-hover"></i>
          </div>
          <span>{{this.$t('lang_revision')}}</span>
          <h3>{{this.$t('lang_revision_msg')}}</h3>
        </div
        ><div
          class="rbcn-step-6"
          :class="{'enable':ProcessShow === 6}"
          data-step="6" 
          @mouseover="changeProcess(6)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-6"></i>
            <i class="sprb_step-6-hover"></i>
          </div>
          <span>{{this.$t('lang_online')}}</span>
          <h3>{{this.$t('lang_online_msg')}}</h3>
        </div>
      </div>

      <div class="underLineHeading">
        <span>{{$t('lang_themeHeading_labelSpecification')}}</span>
      </div>
      <div class="specification-item">
        <div
          :class="{'enable':SpecificationShow === 1}"
          @click="changeSpecification(1)"
        >
          <span class="specification-item-name">{{$t('lang_specification_sort1')}}</span>
          <div class="specification-item-inner" v-html="$t('lang_lottery_specification_sort1_list')"></div>
        </div>
        <div
          :class="{'enable':SpecificationShow === 2}"
          @click="changeSpecification(2)"
        >
          <span class="specification-item-name">{{$t('lang_specification_sort2')}}</span>
          <div class="specification-item-inner" v-html="$t('lang_lottery_specification_sort2_list')"></div>
        </div>
        <div
          :class="{'enable':SpecificationShow === 3}"
          @click="changeSpecification(3)"
        >
          <span class="specification-item-name">{{$t('lang_specification_sort3')}}</span>
          <div class="specification-item-inner" v-html="$t('lang_lottery_specification_sort3_list')"></div>
        </div>
      </div>
      <div class="specification-item">
        <div
          :class="{'enable':SpecificationShow === 4}"
          @click="changeSpecification(4)"
        >
          <span class="specification-item-name">{{$t('lang_specification_sort4')}}</span>
          <div class="specification-item-inner" v-html="$t('lang_lottery_specification_sort4_list')"></div>
        </div>
        <div
          :class="{'enable':SpecificationShow === 5}"
          @click="changeSpecification(5)"
        >
          <span class="specification-item-name">{{$t('lang_specification_sort5')}}</span>
          <div class="specification-item-inner half clearfix" v-html="$t('lang_lottery_specification_sort5_list')"></div>
        </div>
        <div
          :class="{'enable':SpecificationShow === 6}"
          @click="changeSpecification(6)"
        >
          <span class="specification-item-name">{{$t('lang_specification_sort6')}}</span>
          <div class="specification-item-inner" v-html="$t('lang_lottery_specification_sort6_list')"></div>
        </div>
      </div>
    </section>
    <section class="rbcn-contact">
      <span>
        <router-link to="/rbcn"><i v-html="$t('lang_know_labelSolution')"></i></router-link>
        <router-link to="/contact" class="primary"><i>{{$t('lang_knowMore')}}</i></router-link>
        <router-link to="/develop"><i v-html="$t('lang_know_gameConnet')"></i></router-link>
      </span>
    </section>
  </div>
</template>
<script>
import $ from 'jquery'
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'Rblt',
  components: {
    Carousel,
    Slide
  },
  data(){
    return{
      ProcessShow: 1,
      SpecificationShow: 1,
      isMobile: false,
    }
  },
  methods:{
    changeProcess(value){
      this.ProcessShow = value
    },
    changeSpecification(value){
      this.SpecificationShow = value
    },
    getWinSize(){
			const $this = this;
			$(window).resize(function(){
				$this.isMobile = $(window).width() > 996 ? false : true
			})
			$this.isMobile = $(window).width() > 996 ? false : true
		},
		nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    }
  },
  mounted(){
    this.getWinSize()
    this.$store.dispatch('setLoadshow',false)
  },
  beforeDestroy(){
    this.$store.dispatch('setLoadshow',true)
  }
}
</script>
<style lang="sass">
  @import '@css/rblt.sass'
</style>